// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"c82a10bf","213":"2a68d617","669":"71bfef4c"}[chunkId] + ".chunk.js";
};